const BASE_URL = '/api/v1/'; //https://parthiseva.ssssotn.org
//const BASE_URL = 'https://parthiseva.ssssotn.org/api/v1/'; //https://parthiseva.ssssotn.org 'http://localhost:8080/api/v1/';/
const URL_CONSTANTS ={
    'LOGIN': `${BASE_URL}secure/login`,  
    'CURRENT_BATCH': `${BASE_URL}batches/current`,
    'STATS': `${BASE_URL}service/`,
    'GET_SAMITHI_LIST': `${BASE_URL}samithi/list`,
    'GET_DISTRICT_LIST': `${BASE_URL}district/districtInfo`,
    'GET_MEMBER_INFO': `${BASE_URL}member/memberInfo`,
    'GET_DEPLOYMENT_DETAILS':`${BASE_URL}reports/deployment`,
    'GET_SECTOR_DEPLOYMENT_DETAILS':`${BASE_URL}reports/sector-deployment`,
    'GET_DISTRICT_REGISTATION':`${BASE_URL}reports/district-wise-reg`,
    'GET_SAMITHYWISE_REGISTATION':`${BASE_URL}reports/samithi-wise-reg`,
    'GET_REGISTATION_MEMBER_DETAILS':`${BASE_URL}reports/sevdalReports`,
    'GET_CURRENT_BATCH_DETAILS':`${BASE_URL}batches/current`,
    'GET_SEVADAL_DETAILS':`${BASE_URL}reports/sevdalReports`,
    'GET_SECOTR_VALUES':`${BASE_URL}sector/sectors`,
    'GET_DEPLOYMENT_POINT_VALUES':`${BASE_URL}deploymentPoint/deploymentPointInfo`,
    'GET_DISTRICT_VALUES':`${BASE_URL}district/districtInfo`,
    'GET_SAMITHI_VALUES':`${BASE_URL}samithi/samithiInfo`,
    'DEPLOYMENT_POINTS': `${BASE_URL}deploymentPoint/meta`,
    'ALLOCATION_SUMMARY': `${BASE_URL}deploymentPoint/allocationSummary`,
    'SERVICE': `${BASE_URL}service/`,
    'MANAGE_DEPLOYNENT_POINTS':`${BASE_URL}deploymentPoint/deploymentPointInfo/details`,
    'ADD_MANAGE_DEPLOYMENT_POINTS':`${BASE_URL}deploymentPoint/addDeploymentPoint`,
    'EDIT_MANAGE_DEPLOYMENT_POINTS':`${BASE_URL}deploymentPoint/updateDeploymentPoint`,
    'ADD_SECTOR':`${BASE_URL}sector/addSector`,
    'EDIT_SECTOR':`${BASE_URL}sector/updateSector`,
    'SERVICE_DELETE': `${BASE_URL}service/delete`,
    'SERVICE_UNALLOCATE': `${BASE_URL}service/unallocate`,
    'SAMITHI_INFO':`${BASE_URL}samithi/samithiInfo`,
    'MEMBER': `${BASE_URL}member`,
    'ADD_SAMATHI':`${BASE_URL}samithi/addSamithi`,
    'EDIT_SAMATHI':`${BASE_URL}samithi/updateSamithi`,
    'ADD_DISTRICT':`${BASE_URL}district/addDistrict`,
    'EDIT_DISTRICT':`${BASE_URL}district/updateDistrict`,
    'GET_GROUP_LEADER_INFO':`${BASE_URL}groupleader/groupLeaderInfo`,
    'GET_SERVICE_MEMBER_INFO':`${BASE_URL}service/memberServiceInfo`,
    'GROUP_LEADER':`${BASE_URL}groupleader/`,
    'GET_BATCH_INFO':`${BASE_URL}batches/batchInfo`,
    'PERIODS':`${BASE_URL}periods`,
    'UPDATE_BATCH':`${BASE_URL}batches/`,
    'EDIT_PERIODS':`${BASE_URL}periods/upsert`,
    'DELETE_PERIODS':`${BASE_URL}periods/del`,
    'DISTRICT_COUNT':`${BASE_URL}district/districtCount`,
    'MEMBER_COUNT':`${BASE_URL}member/memberCount`,
    'SAMITHI_COUNT':`${BASE_URL}samithi/samithiCount`,
    'DEPLOYMENT_COUNT':`${BASE_URL}deploymentPoint/deploymentPointCount`,
    'GROUP_LEADER_INFO':`${BASE_URL}groupleader/groupLeaderInfo`,
    'UPDATE_PRINT_STATUS':`${BASE_URL}service/print/updatePrintStatus`
}


export default URL_CONSTANTS